import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import axios from "axios";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import BASEURL from "../../Utils/Baseurl";
import { getOnboardLetterByIdQuery, updateOnboardLetterQuery } from "./Queries";
import assets from "../../../config/assestsConfig";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import sign from "../../../assest/LogoAndFavicon/Hrsign/Priyamvada_signature.jpg";

// ============================================================================
// PDF LAYOUT IMPORTS CONFIGURATION
// Mapped according to assetsConfig & App.js
// ============================================================================

// --- Keelis import (Mapped to src/App.js:L28) ---
import KeelisReusablePDFLayout from "../../pdf/ReusablePDFLayout";
import { Page3 as KeelisPage3 } from "../../pdf/pages/Page3";
import { Page4 as KeelisPage4 } from "../../pdf/pages/Page4";
import { Page5 as KeelisPage5 } from "../../pdf/pages/Page5";
import { Page6 as KeelisPage6 } from "../../pdf/pages/Page6";
import { Page7 as KeelisPage7 } from "../../pdf/pages/Page7";
import { Page8 as KeelisPage8 } from "../../pdf/pages/Page8";
import { Page9 as KeelisPage9 } from "../../pdf/pages/Page9";

// --- EG import (Mapped to src/App.js:L33) ---
import EgReusablePDFLayout from "../../egpdf/ReusablePDFLayout";
import { Page3 as EgPage3 } from "../../egpdf/pages/Page3";
import { Page4 as EgPage4 } from "../../egpdf/pages/Page4";
import { Page5 as EgPage5 } from "../../egpdf/pages/Page5";
import { Page6 as EgPage6 } from "../../egpdf/pages/Page6";
import { Page8 as EgPage8 } from "../../egpdf/pages/Page8";
import { Page9 as EgPage9 } from "../../egpdf/pages/Page9";
import { Button, Stack } from "@mui/material";
import { ArrowBack, Download, Save } from "@mui/icons-material";

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================
function formatNameInitials(name) {
  if (!name) return "";
  const parts = name.trim().toLowerCase().split(" ");
  return parts
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

// ============================================================================
// EG APPOINTMENT LETTER TEMPLATE (Mapped to src/pages/egpdf/Appointment.jsx)
// ============================================================================
const EgAppointmentTemplate = ({
  Salarydata,
  candidatedetails,
  Earning,
  Deductions,
  Benefits,
  EarningData,
  salaryType,
  formattedDate,
}) => {
  return (
    <>
      <EgReusablePDFLayout>
        <h1 className="bol">APPOINTMENT LETTER</h1>
        <div className="parentcls">
          <div style={{ display: "flex", margin: "15px 0" }}>
            <div style={{ width: "70%" }}>
              <p className="para">
                Name of the Employee:{" "}
                <span
                  contentEditable
                  suppressContentEditableWarning={true}
                  style={{
                    outline: "none",
                    padding: "2px",
                    cursor: "text",
                  }}
                >
                  {formatNameInitials(candidatedetails?.candidateName)}
                </span>
              </p>
              <p className="para">
                Designation:{" "}
                <span
                  contentEditable
                  suppressContentEditableWarning={true}
                  style={{
                    outline: "none",
                    padding: "2px",
                    cursor: "text",
                  }}
                >
                  {candidatedetails?.position}
                </span>
              </p>
              <p className="para">
                Department:{" "}
                <span
                  contentEditable
                  suppressContentEditableWarning={true}
                  style={{
                    outline: "none",
                    padding: "2px",
                    cursor: "text",
                  }}
                >
                  {candidatedetails?.department}
                </span>
              </p>
            </div>

            <div style={{ width: "50%", marginLeft: "75px" }}>
              <p className="para">
                Date:{" "}
                <span
                  contentEditable
                  suppressContentEditableWarning={true}
                  style={{
                    outline: "none",
                    padding: "2px",
                    cursor: "text",
                  }}
                >
                  {new Date().toLocaleDateString()}
                </span>
              </p>

              <p className="para">
                Emp Code:{" "}
                <span
                  contentEditable
                  suppressContentEditableWarning={true}
                  style={{
                    outline: "none",
                    padding: "2px",
                    cursor: "text",
                  }}
                >
                  {Salarydata?.empCode}
                </span>
              </p>
              <p className="para">
                Location:{" "}
                <span
                  contentEditable
                  suppressContentEditableWarning={true}
                  style={{
                    outline: "none",
                    padding: "2px",
                    cursor: "text",
                  }}
                >
                  Chennai
                </span>{" "}
              </p>
            </div>
          </div>
          <p className="para" style={{ marginTop: "15px" }}>
            Dear {formatNameInitials(candidatedetails?.candidateName)}
          </p>
          <p className="para" style={{ marginTop: "15px" }}>
            <span style={{ wordSpacing: "4px" }}>
              We are pleased to confirm our offer of employment to you for a
              regular full-time position with
            </span>
            <br />{" "}
            <span className="bols">
              EverGuard Insurance Broking Services Private Limited
            </span>{" "}
            as
            <span className="bols">
              <span
                contentEditable
                suppressContentEditableWarning={true}
                style={{
                  width: "100%",
                  fontWeight: "bold",
                  outline: "none",
                  padding: "2px",
                  cursor: "text",
                }}
              >
                {candidatedetails?.position}
              </span>
              /
              <span
                contentEditable
                suppressContentEditableWarning={true}
                style={{
                  width: "100%",
                  fontWeight: "bold",
                  outline: "none",
                  padding: "2px",
                  cursor: "text",
                }}
              >
                {candidatedetails?.department}
              </span>{" "}
            </span>{" "}
            at <span>Chennai </span>. As discussed, this offer is conditional
            upon completion of satisfactory references that could include, but
            is not necessarily limited to, a review of past employment and
            education records. The details of our offer, including the terms and
            conditions of your employment, are annexed as Schedule “A.” herewith.
          </p>
          <p className="para" style={{ marginTop: "15px" }}>
            Please take the time to carefully review our offer. This letter,
            along with the enclosed schedules, outlines the obligations of both
            <span className="bols">
              {" "}
              EverGuard Insurance Broking Services Private Limited{" "}
            </span>
            and yourself with respect to your employment conditions and is
            governed by the laws of India and the Courts of Chennai. It details
            the terms and conditions of your employment with
            <span className="bols">
              {" "}
              EverGuard Insurance Broking Services Private Limited
            </span>{" "}
            and will be deemed your agreed employment contract with
            <span className="bols">
              {" "}
              EverGuard Insurance Broking Services Private Limited
            </span>{" "}
            once signed.
          </p>
          <p className="para">
            Accepting employment will be conditional upon agreeing to and signing
            the attached copy of this letter and the attached Schedule(s)
            herewith.
          </p>
          <p className="para">
            We look forward to welcoming you to team{" "}
            <span className="bols">
              {" "}
              EverGuard Insurance Broking Services Private Limited
            </span>{" "}
            and wish you a successful and rewarding career with us.
          </p>
          <p className="para" style={{ marginTop: "15px" }}>
            For EverGuard Insurance Broking Services Private Limited
          </p>
          <div style={{ marginTop: "15px" }}>
            <img src={sign} width={"180px"} alt="signature" />
          </div>
          <p className="bols">Name of signing authority People Partner</p>
          <div
            style={{
              border: "1px dashed black",
              margin: "15px 0px ",
              marginRight: "155px",
            }}
          ></div>
          <p className="para">
            I, <b>{formatNameInitials(candidatedetails?.candidateName)}</b>,
            acknowledge that I have read, understood and accept this offer and
            the terms and conditions contained in the attached Schedule(s) and
            agree to be bound by the terms and conditions of employment as
            outlined therein.
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              gap: "150px",
            }}
          >
            <p
              className="para"
              style={{
                marginTop: "40px",
                borderTop: "1px solid black",
                width: "50%",
              }}
            >
              Signature
            </p>
            <p
              className="para"
              style={{
                marginTop: "40px",
                borderTop: "1px solid black",
                width: "50%",
              }}
            >
              Date
            </p>
          </div>
        </div>
      </EgReusablePDFLayout>

      <EgReusablePDFLayout>
        <div className="parentcls">
          <p className="bols">Schedule A</p>
          <p className="bols">EverGuard Insurance Broking Services</p>
          <p className="bolds">Terms and Conditions of Employment</p>
          <p className="para">
            The following outlines the terms and conditions of your employment
            with the Company. The Company reserves the right to change these
            terms and conditions as necessary, with due notice.
          </p>
          <p className="para">Commencement of Employment & Title:</p>
          <p className="para" style={{ margin: "15px 0" }}>
            Your employment with the Company will be effective, as of{" "}
            <span className="bols">{formattedDate}</span> . You shall be appointed
            as <span className="bols"> {candidatedetails?.position} </span>{" "}
          </p>
          <p className="bolds">Probationary Period:</p>
          <p className="para">
            To assess your fit within the Company, the first six (6) months of
            your employment will constitute a probationary period. On
            completion of the probationary period, your services may either be
            confirmed or your probationary period may be extended for an
            additional period of six months as decided by the Company with no
            increase in your remuneration unless specifically agreed to in
            writing. Your Confirmation of employment is subject to your
            performance and the discretion of the Company. At any time during
            this probationary period, the Company may terminate your employment
            without cause and without advance notice or pay in lieu of notice. If
            this occurs, we would have no further obligation to you, financial or
            otherwise.
          </p>
          <p className="para" style={{ margin: "15px 0" }}>
            You will be entitled for one day leave during probationary period
            which cannot be carried forward to next month.
          </p>
          {salaryType === "Type One" && (
            <>
              <p className="bolds">Remuneration:</p>
              <p className="para">
                Your salary, allowances and re-imbursement of expenses will be as
                itemized herein below:
              </p>
              <div style={{ marginBottom: "100mm" }}>
                <table style={{ marginTop: "15px" }}>
                  <tbody className="para">
                    <tr>
                      <th>Basic Salary</th>
                      <th>{EarningData[0]?.monthly || 0} ₹ /-per month</th>
                    </tr>
                    <tr>
                      <th>HRA</th>
                      <th>{EarningData[1]?.monthly || 0} ₹ /-per month</th>
                    </tr>
                    <tr>
                      <th>LTA</th>
                      <th> {EarningData[2]?.monthly || 0} ₹ /-per month</th>
                    </tr>
                    <tr>
                      <th>Special Allowance</th>
                      <th>{EarningData[3]?.monthly || 0} ₹ /-per month</th>
                    </tr>
                    <tr>
                      <th>
                        You will be eligible to become a member in the Provident
                        Fund, as per P.F. Act.
                      </th>
                      <th>
                        @12% of Basic Salary subject to a ceiling of INR 15000/-
                        shall be deducted and the company shall make a matching
                        contribution.
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </EgReusablePDFLayout>

      <EgPage3 />
      <EgPage4 />
      <EgPage5 />
      <EgPage6 />
      <EgPage8 />
      <EgPage9
        Earning={Earning}
        RowIDdata={candidatedetails}
        Deductions={Deductions}
        Benefits={Benefits}
        Salarydata={Salarydata}
      />
    </>
  );
};

// ============================================================================
// KEELIS APPOINTMENT LETTER TEMPLATE (Mapped to src/pages/pdf/Appointment.jsx)
// ============================================================================
const KeelisAppointmentTemplate = ({
  Salarydata,
  candidatedetails,
  Earning,
  Deductions,
  Benefits,
  EarningData,
  salaryType,
  formattedDate,
}) => {
  return (
    <>
      <KeelisReusablePDFLayout>
        <h1 className="bol">APPOINTMENT LETTER</h1>
        <div className="parentcls">
          <div style={{ display: "flex", margin: "15px 0" }}>
            <div style={{ width: "70%" }}>
              <p className="para">
                Name of the Employee:{" "}
                {formatNameInitials(candidatedetails?.candidateName)}
              </p>
              <p className="para">
                Designation: {candidatedetails?.position}
              </p>
              <p className="para">
                Department: {candidatedetails?.department}
              </p>
            </div>

            <div style={{ width: "50%", marginLeft: "75px" }}>
              <p className="para">
                Date:{" "}
                <span
                  contentEditable
                  suppressContentEditableWarning={true}
                  style={{
                    outline: "none",
                    padding: "2px",
                    cursor: "text",
                  }}
                >
                  {new Date().toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}
                </span>
              </p>

              <p className="para">Emp Code: {Salarydata?.empCode}</p>
              <p className="para">Location: Chennai</p>
            </div>
          </div>
          <p className="para" style={{ marginTop: "15px" }}>
            Dear {formatNameInitials(candidatedetails?.candidateName)},
          </p>
          <p className="para" style={{ marginTop: "15px" }}>
            <span style={{ wordSpacing: "4px" }}>
              We are pleased to confirm our offer of employment to you for a
              regular full-time position with
            </span>
            <br />{" "}
            <span className="bols">Keel Info Solution Private Limited</span> as{" "}
            <span className="bols">
              {candidatedetails?.position}/{candidatedetails?.department}{" "}
            </span>{" "}
            at <span>Chennai </span>. As discussed, this offer is conditional
            upon completion of satisfactory references that could include, but
            is not necessarily limited to, a review of past employment and
            education records. The details of our offer, including the terms and
            conditions of your employment, are annexed as Schedule “A.” herewith.
          </p>
          <p className="para" style={{ marginTop: "15px" }}>
            Please take the time to carefully review our offer. This letter,
            along with the enclosed schedules, outlines the obligations of both
            <span className="bols"> Keel Info Solution Private Limited </span>
            and yourself with respect to your employment conditions and is
            governed by the laws of India and the Courts of Chennai. It details
            the terms and conditions of your employment with
            <span className="bols"> Keel Info Solution Private Limited</span> and
            will be deemed your agreed employment contract with
            <span className="bols"> Keel Info Solution Private Limited</span>{" "}
            once signed.
          </p>
          <p className="para">
            Accepting employment will be conditional upon agreeing to and signing
            the attached copy of this letter and the attached Schedule(s)
            herewith.
          </p>
          <p className="para">
            We look forward to welcoming you to team{" "}
            <span className="bols"> Keel Info Solution Private Limited</span> and
            wish you a successful and rewarding career with us.
          </p>
          <p className="para" style={{ marginTop: "15px" }}>
            For Keel Info Solution Private Limited
          </p>
          <div style={{ marginTop: "15px" }}>
            <img src={sign} width={"180px"} alt="signature" />
          </div>
          <p className="bols">Name of signing authority People Partner</p>
          <div
            style={{
              border: "1px dashed black",
              margin: "15px 0px ",
              marginRight: "155px",
            }}
          ></div>
          <p className="para">
            I, <b>{formatNameInitials(candidatedetails?.candidateName)}</b>,{" "}
            acknowledge that I have read, understood and accept this offer and
            the terms and conditions contained in the attached Schedule(s) and
            agree to be bound by the terms and conditions of employment as
            outlined therein.
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              gap: "150px",
            }}
          >
            <p
              className="para"
              style={{
                marginTop: "40px",
                borderTop: "1px solid black",
                width: "50%",
              }}
            >
              Signature
            </p>
            <p
              className="para"
              style={{
                marginTop: "40px",
                borderTop: "1px solid black",
                width: "50%",
              }}
            >
              Date
            </p>
          </div>
        </div>
      </KeelisReusablePDFLayout>

      <KeelisReusablePDFLayout>
        <div className="parentcls">
          <p className="bols">Schedule A</p>
          <p className="bols">KEEL INFO SOLUTION</p>
          <p className="bolds">Terms and Conditions of Employment</p>
          <p className="para">
            The following outlines the terms and conditions of your employment
            with the Company. The Company reserves the right to change these
            terms and conditions as necessary, with due notice.
          </p>
          <p className="para">Commencement of Employment & Title:</p>
          <p className="para" style={{ margin: "15px 0" }}>
            Your employment with the Company will be effective, as of{" "}
            <span
              className="bols"
              contentEditable
              suppressContentEditableWarning={true}
              style={{
                outline: "none",
                cursor: "text",
              }}
            >
              {formattedDate}
            </span>{" "}
            . You shall be appointed as{" "}
            <span className="bols"> {candidatedetails?.position} </span>{" "}
          </p>
          <span
            contentEditable
            suppressContentEditableWarning={true}
            style={{
              outline: "none",
              cursor: "text",
            }}
          >
            <p className="bolds">Probationary Period:</p>
            <p className="para">
              To assess your fit within the Company, the first six (6) months of
              your employment will constitute a probationary period. On
              completion of the probationary period, your services may either be
              confirmed or your probationary period may be extended for an
              additional period of six months as decided by the Company with no
              increase in your remuneration unless specifically agreed to in
              writing. Your Confirmation of employment is subject to your
              performance and the discretion of the Company. At any time during
              this probationary period, the Company may terminate your
              employment without cause and without advance notice or pay in lieu
              of notice. If this occurs, we would have no further obligation to
              you, financial or otherwise.
            </p>
            <p className="para" style={{ margin: "15px 0" }}>
              You will be entitled for one day leave during probationary period
              which cannot be carried forward to next month.
            </p>
          </span>
          {salaryType === "Type One" && (
            <>
              <p className="bolds">Remuneration:</p>
              <p className="para">
                Your salary, allowances and re-imbursement of expenses will be as
                itemized herein below:
              </p>
              <div style={{ marginBottom: "80mm" }}>
                <table>
                  <tbody className="para">
                    <tr>
                      <th>Basic Salary</th>
                      <th>{EarningData[0]?.monthly || 0} ₹ /-per month</th>
                    </tr>
                    <tr>
                      <th>HRA</th>
                      <th>{EarningData[1]?.monthly || 0} ₹ /-per month</th>
                    </tr>
                    <tr>
                      <th>LTA</th>
                      <th> {EarningData[2]?.monthly || 0} ₹ /-per month</th>
                    </tr>
                    <tr>
                      <th>Special Allowance</th>
                      <th>{EarningData[3]?.monthly || 0} ₹ /-per month</th>
                    </tr>
                    <tr>
                      <th>
                        You will be eligible to become a member in the Provident
                        Fund, as per P.F. Act.
                      </th>
                      <th>
                        @12% of Basic Salary subject to a ceiling of INR 15000/-
                        shall be deducted and the company shall make a matching
                        contribution.
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </KeelisReusablePDFLayout>

      <KeelisPage3 salaryType={salaryType} />
      <KeelisPage4 />
      <KeelisPage5 />
      <KeelisPage6 />
      <KeelisPage7 />
      <KeelisPage8 />
      <KeelisPage9
        Earning={Earning}
        RowIDdata={candidatedetails}
        Deductions={Deductions}
        Benefits={Benefits}
        Salarydata={Salarydata}
      />
    </>
  );
};

// ============================================================================
// MAIN APPOINTMENT PDF COMPONENT
// ============================================================================
const AppointmentPdf = ({ id: propId }) => {
  const navigate = useNavigate();
  const pdfRef = useRef();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  // Get appointment letter ID from props, URL query parameter (?id=...), or React Router location state
  const appointmentLetterId =
    propId ||
    searchParams.get("id") ||
    location?.state?.id ||
    location?.state;

  const [Salarydata, setSalarydata] = useState(null);
  const [Earning, setEarning] = useState([]);
  const [Deductions, setDeductions] = useState([]);
  const [Benefits, setBenefits] = useState([]);
  const [salaryType, setSalaryType] = useState("Type One");
  const [candidatedetails, setcandidatedetails] = useState({
    candidateName: "",
    empCode: "",
    department: "",
    position: "",
    location: "Chennai",
  });
  const [loading, setLoading] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false)

  useEffect(() => {
    if (appointmentLetterId) {
      getEmployeeOnboardLetterById(appointmentLetterId);
    }
  }, [appointmentLetterId]);

  // Uses getEmployeeOnboardLetterById query (identical to AppointmentLetterForm.js)
  const getEmployeeOnboardLetterById = async (id) => {
    setLoading(true);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: getOnboardLetterByIdQuery,
          variables: {
            id: id,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = response.data?.data?.employeeOnboardLetterById;

      if (result?.success) {
        const data = result?.data;

        // Ensure breakdown is correctly parsed into an array
        let breakdown = data?.breakdown;
        try {
          while (typeof breakdown === "string") {
            breakdown = JSON.parse(breakdown);
          }
        } catch (error) {
          console.error("Error parsing breakdown", error);
        }
        if (!Array.isArray(breakdown)) {
          breakdown = breakdown?.type_two || [];
        }

        setSalarydata({
          ...data,
          empCode: data?.empId || "",
          date: data?.doj || data?.createdAt,
        });

        setSalaryType(
          data?.salaryStructure?.salaryType || "TYPE_ONE"
        );

        setcandidatedetails({
          candidateName: data?.fullName || "",
          empCode: data?.empId || "",
          position: data?.designation || "",
          department: data?.department || "",
          location: "Chennai",
        });

        let earnings = Array.isArray(breakdown)
          ? breakdown.filter((val) => val.type === "Earnings")
          : [];
        let deduction = Array.isArray(breakdown)
          ? breakdown.filter((val) => val.type === "Deductions") || []
          : [];
        let benefits = Array.isArray(breakdown)
          ? breakdown.filter((val) => val.type === "Benefits") || []
          : [];
        const gratuity = benefits.find(
          (item) => item.componentName === "GRATUITY"
        );
        const finalData = gratuity ? [...deduction, gratuity] : deduction;

        setEarning(earnings);
        setDeductions(finalData);
        setBenefits(benefits);

        return data;
      } else {
        console.error(
          "Failed to fetch Appointment letter:",
          result?.message
        );
        Swal.fire({
          position: "center",
          icon: "error",
          title: result?.message || "Failed to fetch Appointment letter",
          showConfirmButton: false,
          timer: 2500,
        });
        return null;
      }
    } catch (error) {
      console.error(
        "Error fetching employee Appointment letter:",
        error
      );
      Swal.fire({
        position: "center",
        icon: "error",
        title:
          error?.response?.data?.errors?.[0]?.message ||
          error?.message ||
          "Failed to fetch Appointment letter",
        showConfirmButton: false,
        timer: 2500,
      });
      return null;
    } finally {
      setLoading(false);
    }
  };

  const EarningData = Earning.filter((val) =>
    /^[A-Za-z]/.test(val?.componentName)
  ).sort((a, b) => a?.componentName?.localeCompare(b?.componentName));

  const Deductiondata = Deductions.filter((val) =>
    /^[A-Za-z]/.test(val?.componentName)
  ).sort((a, b) => a?.componentName?.localeCompare(b?.componentName));

  const Benefitsdata = Benefits.filter((val) =>
    /^[A-Za-z]/.test(val?.componentName)
  );

  const formattedDate = moment(
    Salarydata?.doj || Salarydata?.createdAt || Salarydata?.date || new Date()
  ).format("DD MMMM YYYY");

  const generatePDF = async () => {
    const input = pdfRef.current;
    if (!input) return;

    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const canvas = await html2canvas(input, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");

      const imgWidth = 210; // A4 width in mm
      const pageHeight = 297; // A4 height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      // Add the first page
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Loop to handle multi-page content
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      // Save PDF
      pdf.save(
        `${candidatedetails?.candidateName ? candidatedetails.candidateName.replace(/\s+/g, "_") : "Employee"}_AppointmentLetter.pdf`
      );
    } catch (err) {
      console.error("Error generating PDF:", err);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Failed to generate PDF",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };
  
  const handleDownloadAndSave = async () => {
    const input = pdfRef.current;
    if (!input) return;

    try {
        setLoading(true);

        // Generate LOW-RES PDF for API upload        
        const lowResCanvas = await html2canvas(input, {
            scale: 1,
            useCORS: true,
            backgroundColor: "#ffffff",
        });

        const lowResImgData = lowResCanvas.toDataURL(
            "image/jpeg",
            0.7
        );

        const lowResPdf = new jsPDF("p", "mm", "a4");

        const imgWidth = 210;
        const pageHeight = 297;
        const lowResImgHeight =
            (lowResCanvas.height * imgWidth) /
            lowResCanvas.width;

        let heightLeft = lowResImgHeight;
        let position = 0;

        lowResPdf.addImage(
            lowResImgData,
            "JPEG",
            0,
            position,
            imgWidth,
            lowResImgHeight,
            undefined,
            "FAST"
        );

        heightLeft -= pageHeight;

        while (heightLeft > 0) {
            position = heightLeft - lowResImgHeight;

            lowResPdf.addPage();

            lowResPdf.addImage(
                lowResImgData,
                "JPEG",
                0,
                position,
                imgWidth,
                lowResImgHeight,
                undefined,
                "FAST"
            );

            heightLeft -= pageHeight;
        }

        const pdfBlob = lowResPdf.output("blob");

        // Upload low-resolution PDF
        await updateAppointmentLetter(
            appointmentLetterId,
            pdfBlob
        );
        
        // Generate HIGH-QUALITY PDF for download        
        const highResCanvas = await html2canvas(input, {
            scale: 2,
            useCORS: true,
            backgroundColor: "#ffffff",
        });

        const highResImgData = highResCanvas.toDataURL(
            "image/png"
        );

        const highResPdf = new jsPDF("p", "mm", "a4");

        const highResImgHeight =
            (highResCanvas.height * imgWidth) /
            highResCanvas.width;

        let highResHeightLeft = highResImgHeight;
        let highResPosition = 0;

        highResPdf.addImage(
            highResImgData,
            "PNG",
            0,
            highResPosition,
            imgWidth,
            highResImgHeight
        );

        highResHeightLeft -= pageHeight;

        while (highResHeightLeft > 0) {
            highResPosition =
                highResHeightLeft - highResImgHeight;

            highResPdf.addPage();

            highResPdf.addImage(
                highResImgData,
                "PNG",
                0,
                highResPosition,
                imgWidth,
                highResImgHeight
            );

            highResHeightLeft -= pageHeight;
        }

        // Download high-quality PDF
        highResPdf.save(
            `${
                candidatedetails?.candidateName
                    ? candidatedetails.candidateName.replace(/\s+/g, "_")
                    : "Employee"
            }_AppointmentLetter.pdf`
        );

    } catch (error) {
        console.error(
            "Error generating/uploading PDF:",
            error
        );

        Swal.fire({
            position: "center",
            icon: "error",
            title: "Failed to process PDF",
            text:
                error?.response?.data?.errors?.[0]?.message ||
                error?.message ||
                "Something went wrong",
            showConfirmButton: false,
            timer: 2500,
        });
    } finally {
        setLoading(false);
    }
  };

  const updateAppointmentLetter = async (id, pdfBlob) => {
    try {
        const formData = new FormData();

        formData.append(
            "operations",
            JSON.stringify({
                query: updateOnboardLetterQuery,
                variables: {
                    id,
                    onboard_letter_pdf: null,
                },
            })
        );

        formData.append(
            "map",
            JSON.stringify({
                "0": ["variables.onboard_letter_pdf"],
            })
        );

        formData.append(
            "0",
            pdfBlob,
            "AppointmentLetter.pdf"
        );

        const response = await axios.post(BASEURL, formData);                

        const result = response.data?.data?.updateEmployeeOnboardLetter;

        if (result?.success) {
            setLoading(true)
        } else {
            Swal.fire({
                position: "center",
                icon: "error",
                title:
                    result?.message ||
                    "Failed to update Appointment Letter",
                showConfirmButton: false,
                timer: 2500,
            });
        }
    } catch (error) {
        Swal.fire({
            position: "center",
            icon: "error",
            title:
                error?.response?.data?.errors?.[0]?.message ||
                error?.message ||
                "Failed to update Appointment Letter",
            showConfirmButton: false,
            timer: 2500,
        });
    }
  };

  const templateProps = {
    Salarydata,
    candidatedetails,
    Earning,
    Deductions,
    Benefits,
    EarningData,
    Deductiondata,
    Benefitsdata,
    salaryType,
    formattedDate,
  };

  return (
    <DashboardLayout>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            marginBottom: "15px",
          }}
        >
            <Button
                onClick={() => navigate("/appointment-letter")}
                variant="contained"
                startIcon={<ArrowBack />}
                sx={{
                    backgroundColor: "#3f4277",
                    color: "#fff",
                    borderRadius: "5px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    padding: "8px 16px",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                    "&:hover": {
                        backgroundColor: "#34365f",
                    },
                }}
            >
                Back
            </Button>


            <Button
              onClick={handleDownloadAndSave}
              variant="contained"
              disabled={loading}
              startIcon={<Download />}
              sx={{
                  backgroundColor: "#3f4277",
                  color: "#fff",
                  borderRadius: "5px",
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "8px 16px",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.15)",

                  "&:hover": {
                      backgroundColor: "#34365f",
                  },

                  "&.Mui-disabled": {
                      backgroundColor: "#9a9cb8",
                      color: "#fff",
                      cursor: "not-allowed",
                  },
              }}
          >
              {loading ? "Processing..." : "Download"}
          </Button>
        </div>

        {/* Parent container for PDF */}
        <div
          ref={pdfRef}
          className="pdfcontainer"
          style={{
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "210mm",
            padding: "0",
            margin: "0 auto",
          }}
        >
          {/* Render PDF Template according to assetsConfig company */}
          {assets.company === "Eg" ? (
            <EgAppointmentTemplate {...templateProps} />
          ) : (
            <KeelisAppointmentTemplate {...templateProps} />
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AppointmentPdf;